/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/** SortDirection */
export enum SortDirection {
  Asc = "asc",
  Desc = "desc",
}

/** ReviewStatus */
export enum ReviewStatus {
  Pending = "pending",
  Approved = "approved",
  Rejected = "rejected",
}

/** ParticipationRequestStatus */
export enum ParticipationRequestStatus {
  New = "new",
  InReview = "in_review",
  Processed = "processed",
  Rejected = "rejected",
}

/** CreationRequestStatus */
export enum CreationRequestStatus {
  New = "new",
  InReview = "in_review",
  Approved = "approved",
  Rejected = "rejected",
}

/** CompetitionStatus */
export enum CompetitionStatus {
  Draft = "draft",
  RegistrationOpen = "registration_open",
  RegistrationClosed = "registration_closed",
  Finished = "finished",
  Cancelled = "cancelled",
}

/** CatalogProfileType */
export enum CatalogProfileType {
  School = "school",
  Trainer = "trainer",
}

/** CatalogAttachmentData */
export interface CatalogAttachment {
  id: number;
  title: string | null;
  name: string;
  original_name: string;
  mime: string;
  size: number;
  url: string;
}

/** CatalogContactData */
export interface CatalogContact {
  email: string;
  phone: string;
  address: string;
  site: string | null;
}

/** CompetitionParticipationRequestCreatedData */
export interface CompetitionParticipationRequestCreated {
  id: string;
  status: ParticipationRequestStatus;
}

/** CreationRequestCreatedData */
export interface CreationRequestCreated {
  id: string;
  status: CreationRequestStatus;
}

/** DirectionReferenceData */
export interface DirectionRef {
  id: string;
  name: string;
  slug: string;
  icon: string;
}

/** LessonTypeReferenceData */
export interface LessonTypeRef {
  id: string;
  name: string;
  slug: string;
}

/** PageMetaData */
export interface PageMeta {
  page: number;
  per_page: number;
  total: number;
  last_page: number;
}

/** PaginatedResultDataOfPublicCompetitionData */
export interface PaginatedResultDataOfPublicCompetition {
  items: Competition[];
  meta: PageMeta;
}

/** PaginatedResultDataOfPublicNewsData */
export interface PaginatedResultDataOfPublicNews {
  items: News[];
  meta: PageMeta;
}

/** PaginatedResultDataOfPublicSchoolData */
export interface PaginatedResultDataOfPublicSchool {
  items: School[];
  meta: PageMeta;
}

/** PaginatedResultDataOfPublicTrainerData */
export interface PaginatedResultDataOfPublicTrainer {
  items: Trainer[];
  meta: PageMeta;
}

/** PublicCompetitionCategoryData */
export interface CompetitionCategory {
  id: string;
  name: string;
  description: string | null;
  max_participants: number;
  sort: number;
}

/** PublicCompetitionData */
export interface Competition {
  id: string;
  title: string;
  slug: string;
  organizer_name: string;
  location_name: string;
  address: string | null;
  description: string | null;
  participants_count: number;
  max_participants: number | null;
  image_url: string | null;
  starts_at: string;
  ends_at: string;
  status: CompetitionStatus;
  region: RegionRef;
  direction: DirectionRef;
}

/** PublicCompetitionDetailsData */
export interface CompetitionDetails {
  id: string;
  title: string;
  slug: string;
  organizer_name: string;
  competition_scoring_type: string;
  tournament_system: string;
  location_name: string;
  address: string | null;
  description: string | null;
  participants_count: number;
  max_participants: number | null;
  entry_fee: number | null;
  prize_fund: number | null;
  rules_and_regulations: string | null;
  image_url: string | null;
  detail_image_url: string | null;
  starts_at: string;
  ends_at: string;
  status: CompetitionStatus;
  region: RegionRef;
  direction: DirectionRef;
  categories: CompetitionCategory[];
  gallery: CatalogAttachment[];
  documents: CatalogAttachment[];
}

/** PublicDirectionData */
export interface Direction {
  id: string;
  parent_id: string | null;
  name: string;
  slug: string;
  description: string | null;
  icon: string;
  image_url: string | null;
}

/** PublicDirectionPageData */
export interface DirectionPage {
  direction: Direction;
  subdirections: Direction[];
  schools: School[];
  trainers: Trainer[];
  competitions: Competition[];
  news: News[];
}

/** PublicHomePageData */
export interface HomePage {
  schools: School[];
  trainers: Trainer[];
  news: News[];
  competitions: Competition[];
}

/** PublicNewsData */
export interface News {
  id: string;
  title: string;
  slug: string;
  preview_description: string;
  image_url: string | null;
  published_at: string;
  direction: DirectionRef | null;
  region: RegionRef;
  directions: DirectionRef[];
  source: SourceRef;
}

/** PublicNewsDetailsData */
export interface NewsDetails {
  id: string;
  title: string;
  slug: string;
  views_count: number;
  preview_description: string;
  description: string;
  image_url: string | null;
  detail_image_url: string | null;
  published_at: string;
  direction: DirectionRef | null;
  region: RegionRef;
  directions: DirectionRef[];
  source: SourceRef;
  similar_news: News[];
  pride_entries: PrideEntry[];
}

/** PublicPrideEntryData */
export interface PrideEntry {
  id: string;
  name: string;
  achievements: string[];
  description: string | null;
  image_url: string | null;
  direction: DirectionRef;
}

/** PublicProfileTrainingScheduleDayData */
export interface ProfileTrainingScheduleDay {
  day_of_week: number;
  day_of_week_label: string;
  entries: ProfileTrainingScheduleEntry[];
}

/** PublicProfileTrainingScheduleEntryData */
export interface ProfileTrainingScheduleEntry {
  training_id: string;
  training_title: string;
  training_description: string | null;
  direction: DirectionRef;
  lesson_type: LessonTypeRef;
  location_name: string | null;
  start_time: string;
  end_time: string;
  capacity: number | null;
  price: number | null;
}

/** PublicReviewData */
export interface Review {
  id: string;
  author_name: string;
  rating: number;
  content: string;
  created_at: string;
}

/** PublicSchoolData */
export interface School {
  id: string;
  name: string;
  slug: string;
  description: string | null;
  rating: number | null;
  students_count: number;
  trainers_count: number;
  image_url: string | null;
  region: RegionRef;
  directions: DirectionRef[];
  lesson_types: LessonTypeRef[];
}

/** PublicSchoolDetailsData */
export interface SchoolDetails {
  id: string;
  name: string;
  slug: string;
  description: string | null;
  rating: number | null;
  contact: CatalogContact | null;
  students_count: number;
  trainers_count: number;
  image_url: string | null;
  detail_image_url: string | null;
  region: RegionRef;
  directions: DirectionRef[];
  lesson_types: LessonTypeRef[];
  pride_entries: PrideEntry[];
  gallery: CatalogAttachment[];
  files: CatalogAttachment[];
  trainers: Trainer[];
}

/** PublicTrainerData */
export interface Trainer {
  id: string;
  name: string;
  slug: string;
  description: string | null;
  rating: number | null;
  students_count: number;
  schools_count: number;
  image_url: string | null;
  region: RegionRef;
  directions: DirectionRef[];
  lesson_types: LessonTypeRef[];
}

/** PublicTrainerDetailsData */
export interface TrainerDetails {
  id: string;
  name: string;
  slug: string;
  description: string | null;
  rating: number | null;
  contact: CatalogContact | null;
  experience_years: number | null;
  educations: string[];
  achievements: string[];
  students_count: number;
  image_url: string | null;
  region: RegionRef;
  directions: DirectionRef[];
  lesson_types: LessonTypeRef[];
  pride_entries: PrideEntry[];
  gallery: CatalogAttachment[];
  files: CatalogAttachment[];
}

/** RegionReferenceData */
export interface RegionRef {
  id: string;
  name: string;
  full_name: string;
}

/** ReviewCreatedData */
export interface ReviewCreated {
  id: string;
  status: ReviewStatus;
}

/** SourceReferenceData */
export interface SourceRef {
  type: CatalogProfileType;
  id: string;
  name: string;
  slug: string;
}

/** StoreCompetitionParticipationRequestRequest */
export interface StoreCompetitionParticipationRequest {
  /** @maxLength 255 */
  participant_name: string;
  /**
   * @format email
   * @maxLength 255
   */
  email: string;
  /** @maxLength 255 */
  phone: string;
  /** @format date-time */
  birth_date: string;
  /** @format uuid */
  competition_category_id?: string | null;
  /** @maxLength 255 */
  team_name?: string | null;
  /** @maxLength 5000 */
  additional_information?: string | null;
}

/** StoreReviewRequest */
export interface StoreReview {
  /** @maxLength 255 */
  author_name: string;
  /**
   * @format email
   * @maxLength 255
   */
  email: string;
  /**
   * @min 1
   * @max 5
   */
  rating: number;
  /** @maxLength 5000 */
  content: string;
}

/** StoreSchoolCreationRequestRequest */
export interface StoreSchoolCreationRequest {
  /** @maxLength 255 */
  name: string;
  /**
   * @format email
   * @maxLength 255
   */
  email: string;
  /** @maxLength 255 */
  phone: string;
  /** @maxLength 1000 */
  address: string;
  /** @maxLength 255 */
  site?: string | null;
  /** @format uuid */
  region_id: string;
  /** @maxLength 255 */
  license_number: string;
  description: string;
  /** @minItems 1 */
  direction_ids: string[];
  file_attachment_ids?: number[] | null;
}

/** StoreTrainerCreationRequestRequest */
export interface StoreTrainerCreationRequest {
  /** @maxLength 255 */
  name: string;
  /**
   * @format email
   * @maxLength 255
   */
  email: string;
  /** @maxLength 255 */
  phone: string;
  /** @maxLength 255 */
  site?: string | null;
  /** @format uuid */
  region_id: string;
  /** @format uuid */
  school_id?: string | null;
  /** @min 1 */
  experience_years: number;
  educations: string[];
  achievements: string[];
  /** @minItems 1 */
  direction_ids: string[];
}

/** StoreTrainingSignupRequestRequest */
export interface StoreTrainingSignupRequest {
  /** @maxLength 255 */
  visitor_name: string;
  /**
   * @format email
   * @maxLength 255
   */
  email: string;
  /** @maxLength 255 */
  phone: string;
  /** @maxLength 2000 */
  message?: string | null;
}

/** TrainingSignupRequestCreatedData */
export interface TrainingSignupRequestCreated {
  id: string;
  status: ParticipationRequestStatus;
}

export type QueryParamsType = Record<string | number, any>;
export type ResponseFormat = keyof Omit<Body, "body" | "bodyUsed">;

export interface FullRequestParams extends Omit<RequestInit, "body"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseFormat;
  /** request body */
  body?: unknown;
  /** base url */
  baseUrl?: string;
  /** request cancellation token */
  cancelToken?: CancelToken;
}

export type RequestParams = Omit<
  FullRequestParams,
  "body" | "method" | "query" | "path"
>;

export interface ApiConfig<SecurityDataType = unknown> {
  baseUrl?: string;
  baseApiParams?: Omit<RequestParams, "baseUrl" | "cancelToken" | "signal">;
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<RequestParams | void> | RequestParams | void;
  customFetch?: typeof fetch;
}

export interface HttpResponse<D extends unknown, E extends unknown = unknown>
  extends Response {
  data: D;
  error: E;
}

type CancelToken = Symbol | string | number;

export enum ContentType {
  Json = "application/json",
  JsonApi = "application/vnd.api+json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public baseUrl: string = "http://sport-portal.local/api";
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private abortControllers = new Map<CancelToken, AbortController>();
  private customFetch = (...fetchParams: Parameters<typeof fetch>) =>
    fetch(...fetchParams);

  private baseApiParams: RequestParams = {
    credentials: "same-origin",
    headers: {},
    redirect: "follow",
    referrerPolicy: "no-referrer",
  };

  constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
    Object.assign(this, apiConfig);
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected encodeQueryParam(key: string, value: any) {
    const encodedKey = encodeURIComponent(key);
    return `${encodedKey}=${encodeURIComponent(typeof value === "number" ? value : `${value}`)}`;
  }

  protected addQueryParam(query: QueryParamsType, key: string) {
    return this.encodeQueryParam(key, query[key]);
  }

  protected addArrayQueryParam(query: QueryParamsType, key: string) {
    const value = query[key];
    return value.map((v: any) => this.encodeQueryParam(key, v)).join("&");
  }

  protected toQueryString(rawQuery?: QueryParamsType): string {
    const query = rawQuery || {};
    const keys = Object.keys(query).filter(
      (key) => "undefined" !== typeof query[key],
    );
    return keys
      .map((key) =>
        Array.isArray(query[key])
          ? this.addArrayQueryParam(query, key)
          : this.addQueryParam(query, key),
      )
      .join("&");
  }

  protected addQueryParams(rawQuery?: QueryParamsType): string {
    const queryString = this.toQueryString(rawQuery);
    return queryString ? `?${queryString}` : "";
  }

  private contentFormatters: Record<ContentType, (input: any) => any> = {
    [ContentType.Json]: (input: any) =>
      input !== null && (typeof input === "object" || typeof input === "string")
        ? JSON.stringify(input)
        : input,
    [ContentType.JsonApi]: (input: any) =>
      input !== null && (typeof input === "object" || typeof input === "string")
        ? JSON.stringify(input)
        : input,
    [ContentType.Text]: (input: any) =>
      input !== null && typeof input !== "string"
        ? JSON.stringify(input)
        : input,
    [ContentType.FormData]: (input: any) => {
      if (input instanceof FormData) {
        return input;
      }

      return Object.keys(input || {}).reduce((formData, key) => {
        const property = input[key];
        formData.append(
          key,
          property instanceof Blob
            ? property
            : typeof property === "object" && property !== null
              ? JSON.stringify(property)
              : `${property}`,
        );
        return formData;
      }, new FormData());
    },
    [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input),
  };

  protected mergeRequestParams(
    params1: RequestParams,
    params2?: RequestParams,
  ): RequestParams {
    return {
      ...this.baseApiParams,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...(this.baseApiParams.headers || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected createAbortSignal = (
    cancelToken: CancelToken,
  ): AbortSignal | undefined => {
    if (this.abortControllers.has(cancelToken)) {
      const abortController = this.abortControllers.get(cancelToken);
      if (abortController) {
        return abortController.signal;
      }
      return void 0;
    }

    const abortController = new AbortController();
    this.abortControllers.set(cancelToken, abortController);
    return abortController.signal;
  };

  public abortRequest = (cancelToken: CancelToken) => {
    const abortController = this.abortControllers.get(cancelToken);

    if (abortController) {
      abortController.abort();
      this.abortControllers.delete(cancelToken);
    }
  };

  public request = async <T = any, E = any>({
    body,
    secure,
    path,
    type,
    query,
    format,
    baseUrl,
    cancelToken,
    ...params
  }: FullRequestParams): Promise<HttpResponse<T, E>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.baseApiParams.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const queryString = query && this.toQueryString(query);
    const payloadFormatter = this.contentFormatters[type || ContentType.Json];
    const responseFormat = format || requestParams.format;

    return this.customFetch(
      `${baseUrl || this.baseUrl || ""}${path}${queryString ? `?${queryString}` : ""}`,
      {
        ...requestParams,
        headers: {
          ...(requestParams.headers || {}),
          ...(type && type !== ContentType.FormData
            ? { "Content-Type": type }
            : {}),
        },
        signal:
          (cancelToken
            ? this.createAbortSignal(cancelToken)
            : requestParams.signal) || null,
        body:
          typeof body === "undefined" || body === null
            ? null
            : payloadFormatter(body),
      },
    ).then(async (response) => {
      const r = response as HttpResponse<T, E>;
      r.data = null as unknown as T;
      r.error = null as unknown as E;

      const responseToParse = responseFormat ? response.clone() : response;
      const data = !responseFormat
        ? r
        : await responseToParse[responseFormat]()
            .then((data) => {
              if (r.ok) {
                r.data = data;
              } else {
                r.error = data;
              }
              return r;
            })
            .catch((e) => {
              r.error = e;
              return r;
            });

      if (cancelToken) {
        this.abortControllers.delete(cancelToken);
      }

      if (!response.ok) throw data;
      return data;
    });
  };
}

/**
 * @title SportPortal
 * @version 12.2.0
 * @baseUrl http://sport-portal.local/api
 * @contact Ruslan Shikhmagomedov <shahruslan.m@gmail.com>
 */
export class Api<
  SecurityDataType extends unknown,
> extends HttpClient<SecurityDataType> {
  public = {
    /**
     * No description
     *
     * @tags CompetitionParticipationRequests
     * @name Store
     * @summary Отправить заявку на участие в соревновании
     * @request POST:/public/v1/competitions/{competition}/participation-requests
     */
    store: (
      competition: string,
      data: StoreCompetitionParticipationRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        CompetitionParticipationRequestCreated,
        | {
            /** Application error message. */
            message: string;
            /** Application error code. */
            code: number;
            /** Application exception class basename. */
            exception: string;
          }
        | {
            /** Errors overview. */
            message: string;
            /** A detailed description of each field that failed validation. */
            errors: Record<string, string[]>;
          }
      >({
        path: `/public/v1/competitions/${competition}/participation-requests`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Competitions
     * @name Competitions
     * @summary Получить список соревнований
     * @request GET:/public/v1/competitions
     */
    competitions: (
      query: {
        /** @min 1 */
        page?: number | null;
        /**
         * @min 1
         * @max 50
         */
        per_page?: number | null;
        /** @format uuid */
        region_id: string;
        /** @format uuid */
        direction_id?: string | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        PaginatedResultDataOfPublicCompetition,
        | {
            /** Errors overview. */
            message: string;
            /** A detailed description of each field that failed validation. */
            errors: Record<string, string[]>;
          }
        | {
            /** Application error message. */
            message: string;
            /** Application error code. */
            code: number;
            /** Application exception class basename. */
            exception: string;
          }
      >({
        path: `/public/v1/competitions`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Competitions
     * @name CompetitionsDetail
     * @summary Получить детальную информацию о соревновании
     * @request GET:/public/v1/competitions/{competition}
     */
    "competitions.detail": (competition: string, params: RequestParams = {}) =>
      this.request<
        CompetitionDetails,
        {
          /** Application error message. */
          message: string;
          /** Application error code. */
          code: number;
          /** Application exception class basename. */
          exception: string;
        }
      >({
        path: `/public/v1/competitions/${competition}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CreationRequests
     * @name CreationRequestsStoreSchool
     * @summary Создать заявку на добавление школы
     * @request POST:/public/v1/schools/register
     */
    creationRequestsStoreSchool: (
      data: StoreSchoolCreationRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        CreationRequestCreated,
        | {
            /** Errors overview. */
            message: string;
            /** A detailed description of each field that failed validation. */
            errors: Record<string, string[]>;
          }
        | {
            /** Application error message. */
            message: string;
            /** Application error code. */
            code: number;
            /** Application exception class basename. */
            exception: string;
          }
      >({
        path: `/public/v1/schools/register`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CreationRequests
     * @name CreationRequestsStoreTrainer
     * @summary Создать заявку на добавление тренера
     * @request POST:/public/v1/trainers/register
     */
    creationRequestsStoreTrainer: (
      data: StoreTrainerCreationRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        CreationRequestCreated,
        | {
            /** Errors overview. */
            message: string;
            /** A detailed description of each field that failed validation. */
            errors: Record<string, string[]>;
          }
        | {
            /** Application error message. */
            message: string;
            /** Application error code. */
            code: number;
            /** Application exception class basename. */
            exception: string;
          }
      >({
        path: `/public/v1/trainers/register`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Directions
     * @name Directions
     * @summary Получить список направлений
     * @request GET:/public/v1/directions
     */
    directions: (params: RequestParams = {}) =>
      this.request<
        Direction[],
        {
          /** Application error message. */
          message: string;
          /** Application error code. */
          code: number;
          /** Application exception class basename. */
          exception: string;
        }
      >({
        path: `/public/v1/directions`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Directions
     * @name Subdirections
     * @summary Получение списка поддиректорий
     * @request GET:/public/v1/directions/{direction}/subdirections
     */
    subdirections: (direction: string, params: RequestParams = {}) =>
      this.request<
        Direction[],
        {
          /** Application error message. */
          message: string;
          /** Application error code. */
          code: number;
          /** Application exception class basename. */
          exception: string;
        }
      >({
        path: `/public/v1/directions/${direction}/subdirections`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags LessonTypes
     * @name LessonTypes
     * @summary Получить список типов занятий
     * @request GET:/public/v1/lesson-types
     */
    lessonTypes: (params: RequestParams = {}) =>
      this.request<
        LessonTypeRef[],
        {
          /** Application error message. */
          message: string;
          /** Application error code. */
          code: number;
          /** Application exception class basename. */
          exception: string;
        }
      >({
        path: `/public/v1/lesson-types`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags News
     * @name News
     * @summary Получить список новостей
     * @request GET:/public/v1/news
     */
    news: (
      query: {
        /** @min 1 */
        page?: number | null;
        /**
         * @min 1
         * @max 50
         */
        per_page?: number | null;
        /** @format uuid */
        region_id: string;
        /** @format uuid */
        direction_id?: string | null;
        /**
         * @minLength 3
         * @maxLength 255
         */
        q?: string | null;
        sort_by?: "published_at" | "title";
        sort_direction?: SortDirection | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        PaginatedResultDataOfPublicNews,
        | {
            /** Errors overview. */
            message: string;
            /** A detailed description of each field that failed validation. */
            errors: Record<string, string[]>;
          }
        | {
            /** Application error message. */
            message: string;
            /** Application error code. */
            code: number;
            /** Application exception class basename. */
            exception: string;
          }
      >({
        path: `/public/v1/news`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags News
     * @name NewsDetail
     * @summary Получить детальную информацию о новости
     * @request GET:/public/v1/news/{news}
     */
    "news.detail": (news: string, params: RequestParams = {}) =>
      this.request<
        NewsDetails,
        {
          /** Application error message. */
          message: string;
          /** Application error code. */
          code: number;
          /** Application exception class basename. */
          exception: string;
        }
      >({
        path: `/public/v1/news/${news}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Pages
     * @name Home
     * @summary Получить данные для главной страницы
     * @request GET:/public/v1/pages/home
     */
    home: (
      query: {
        /** @format uuid */
        region_id: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        HomePage,
        | {
            /** Errors overview. */
            message: string;
            /** A detailed description of each field that failed validation. */
            errors: Record<string, string[]>;
          }
        | {
            /** Application error message. */
            message: string;
            /** Application error code. */
            code: number;
            /** Application exception class basename. */
            exception: string;
          }
      >({
        path: `/public/v1/pages/home`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Pages
     * @name Direction
     * @summary Получить данные для страницы направления
     * @request GET:/public/v1/pages/direction/{direction}
     */
    direction: (
      direction: string,
      query: {
        /** @format uuid */
        region_id: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        DirectionPage,
        | {
            /** Application error message. */
            message: string;
            /** Application error code. */
            code: number;
            /** Application exception class basename. */
            exception: string;
          }
        | {
            /** Errors overview. */
            message: string;
            /** A detailed description of each field that failed validation. */
            errors: Record<string, string[]>;
          }
      >({
        path: `/public/v1/pages/direction/${direction}`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PrideEntries
     * @name SchoolPrideEntries
     * @summary Получить раздел «Наша гордость» школы
     * @request GET:/public/v1/schools/{school}/pride-entries
     */
    schoolPrideEntries: (school: string, params: RequestParams = {}) =>
      this.request<
        PrideEntry[],
        {
          /** Application error message. */
          message: string;
          /** Application error code. */
          code: number;
          /** Application exception class basename. */
          exception: string;
        }
      >({
        path: `/public/v1/schools/${school}/pride-entries`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PrideEntries
     * @name TrainerPrideEntries
     * @summary Получить раздел «Наша гордость» тренера
     * @request GET:/public/v1/trainers/{trainer}/pride-entries
     */
    trainerPrideEntries: (trainer: string, params: RequestParams = {}) =>
      this.request<
        PrideEntry[],
        {
          /** Application error message. */
          message: string;
          /** Application error code. */
          code: number;
          /** Application exception class basename. */
          exception: string;
        }
      >({
        path: `/public/v1/trainers/${trainer}/pride-entries`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Regions
     * @name Regions
     * @summary Получить список регионов
     * @request GET:/public/v1/regions
     */
    regions: (
      query?: {
        /** @maxLength 50 */
        q?: string | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        RegionRef[],
        | {
            /** Errors overview. */
            message: string;
            /** A detailed description of each field that failed validation. */
            errors: Record<string, string[]>;
          }
        | {
            /** Application error message. */
            message: string;
            /** Application error code. */
            code: number;
            /** Application exception class basename. */
            exception: string;
          }
      >({
        path: `/public/v1/regions`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reviews
     * @name SchoolReviews
     * @summary Получить отзывы школы
     * @request GET:/public/v1/schools/{school}/reviews
     */
    schoolReviews: (school: string, params: RequestParams = {}) =>
      this.request<
        Review[],
        {
          /** Application error message. */
          message: string;
          /** Application error code. */
          code: number;
          /** Application exception class basename. */
          exception: string;
        }
      >({
        path: `/public/v1/schools/${school}/reviews`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reviews
     * @name StoreSchoolReview
     * @summary Оставить отзыв школе
     * @request POST:/public/v1/schools/{school}/reviews
     */
    storeSchoolReview: (
      school: string,
      data: StoreReview,
      params: RequestParams = {},
    ) =>
      this.request<
        ReviewCreated,
        | {
            /** Application error message. */
            message: string;
            /** Application error code. */
            code: number;
            /** Application exception class basename. */
            exception: string;
          }
        | {
            /** Errors overview. */
            message: string;
            /** A detailed description of each field that failed validation. */
            errors: Record<string, string[]>;
          }
      >({
        path: `/public/v1/schools/${school}/reviews`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reviews
     * @name TrainerReviews
     * @summary Получить отзывы тренера
     * @request GET:/public/v1/trainers/{trainer}/reviews
     */
    trainerReviews: (trainer: string, params: RequestParams = {}) =>
      this.request<
        Review[],
        {
          /** Application error message. */
          message: string;
          /** Application error code. */
          code: number;
          /** Application exception class basename. */
          exception: string;
        }
      >({
        path: `/public/v1/trainers/${trainer}/reviews`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reviews
     * @name StoreTrainerReview
     * @summary Оставить отзыв тренеру
     * @request POST:/public/v1/trainers/{trainer}/reviews
     */
    storeTrainerReview: (
      trainer: string,
      data: StoreReview,
      params: RequestParams = {},
    ) =>
      this.request<
        ReviewCreated,
        | {
            /** Application error message. */
            message: string;
            /** Application error code. */
            code: number;
            /** Application exception class basename. */
            exception: string;
          }
        | {
            /** Errors overview. */
            message: string;
            /** A detailed description of each field that failed validation. */
            errors: Record<string, string[]>;
          }
      >({
        path: `/public/v1/trainers/${trainer}/reviews`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reviews
     * @name CompetitionReviews
     * @summary Получить отзывы соревнования
     * @request GET:/public/v1/competitions/{competition}/reviews
     */
    competitionReviews: (competition: string, params: RequestParams = {}) =>
      this.request<
        Review[],
        {
          /** Application error message. */
          message: string;
          /** Application error code. */
          code: number;
          /** Application exception class basename. */
          exception: string;
        }
      >({
        path: `/public/v1/competitions/${competition}/reviews`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reviews
     * @name StoreCompetitionReview
     * @summary Оставить отзыв соревнованию
     * @request POST:/public/v1/competitions/{competition}/reviews
     */
    storeCompetitionReview: (
      competition: string,
      data: StoreReview,
      params: RequestParams = {},
    ) =>
      this.request<
        ReviewCreated,
        | {
            /** Application error message. */
            message: string;
            /** Application error code. */
            code: number;
            /** Application exception class basename. */
            exception: string;
          }
        | {
            /** Errors overview. */
            message: string;
            /** A detailed description of each field that failed validation. */
            errors: Record<string, string[]>;
          }
      >({
        path: `/public/v1/competitions/${competition}/reviews`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Schools
     * @name Schools
     * @summary Получить список школ
     * @request GET:/public/v1/schools
     */
    schools: (
      query: {
        /** @min 1 */
        page?: number | null;
        /**
         * @min 1
         * @max 50
         */
        per_page?: number | null;
        /** @format uuid */
        region_id: string;
        /** @format uuid */
        direction_id?: string | null;
        /** @format uuid */
        lesson_type_id?: string | null;
        is_top?: boolean | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        PaginatedResultDataOfPublicSchool,
        | {
            /** Errors overview. */
            message: string;
            /** A detailed description of each field that failed validation. */
            errors: Record<string, string[]>;
          }
        | {
            /** Application error message. */
            message: string;
            /** Application error code. */
            code: number;
            /** Application exception class basename. */
            exception: string;
          }
      >({
        path: `/public/v1/schools`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Schools
     * @name SchoolsDetail
     * @summary Получить детальную информацию о школе
     * @request GET:/public/v1/schools/{school}
     */
    "schools.detail": (school: string, params: RequestParams = {}) =>
      this.request<
        SchoolDetails,
        {
          /** Application error message. */
          message: string;
          /** Application error code. */
          code: number;
          /** Application exception class basename. */
          exception: string;
        }
      >({
        path: `/public/v1/schools/${school}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Trainers
     * @name Trainers
     * @summary Получить список тренеров
     * @request GET:/public/v1/trainers
     */
    trainers: (
      query: {
        /** @min 1 */
        page?: number | null;
        /**
         * @min 1
         * @max 50
         */
        per_page?: number | null;
        /** @format uuid */
        region_id: string;
        /** @format uuid */
        direction_id?: string | null;
        /** @format uuid */
        lesson_type_id?: string | null;
        is_top?: boolean | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        PaginatedResultDataOfPublicTrainer,
        | {
            /** Errors overview. */
            message: string;
            /** A detailed description of each field that failed validation. */
            errors: Record<string, string[]>;
          }
        | {
            /** Application error message. */
            message: string;
            /** Application error code. */
            code: number;
            /** Application exception class basename. */
            exception: string;
          }
      >({
        path: `/public/v1/trainers`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Trainers
     * @name TrainersDetail
     * @summary Получить детальную информацию о тренере
     * @request GET:/public/v1/trainers/{trainer}
     */
    "trainers.detail": (trainer: string, params: RequestParams = {}) =>
      this.request<
        TrainerDetails,
        {
          /** Application error message. */
          message: string;
          /** Application error code. */
          code: number;
          /** Application exception class basename. */
          exception: string;
        }
      >({
        path: `/public/v1/trainers/${trainer}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags TrainingSchedules
     * @name SchoolSchedule
     * @summary Получить недельное расписание школы
     * @request GET:/public/v1/schools/{school}/schedule
     */
    schoolSchedule: (school: string, params: RequestParams = {}) =>
      this.request<
        ProfileTrainingScheduleDay[],
        {
          /** Application error message. */
          message: string;
          /** Application error code. */
          code: number;
          /** Application exception class basename. */
          exception: string;
        }
      >({
        path: `/public/v1/schools/${school}/schedule`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags TrainingSchedules
     * @name TrainerSchedule
     * @summary Получить недельное расписание тренера
     * @request GET:/public/v1/trainers/{trainer}/schedule
     */
    trainerSchedule: (trainer: string, params: RequestParams = {}) =>
      this.request<
        ProfileTrainingScheduleDay[],
        {
          /** Application error message. */
          message: string;
          /** Application error code. */
          code: number;
          /** Application exception class basename. */
          exception: string;
        }
      >({
        path: `/public/v1/trainers/${trainer}/schedule`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags TrainingSignupRequests
     * @name TrainingSignupRequestsStoreSchool
     * @summary Отправить заявку на запись на занятие в школу
     * @request POST:/public/v1/schools/{school}/training-requests
     */
    trainingSignupRequestsStoreSchool: (
      school: string,
      data: StoreTrainingSignupRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        TrainingSignupRequestCreated,
        | {
            /** Application error message. */
            message: string;
            /** Application error code. */
            code: number;
            /** Application exception class basename. */
            exception: string;
          }
        | {
            /** Errors overview. */
            message: string;
            /** A detailed description of each field that failed validation. */
            errors: Record<string, string[]>;
          }
      >({
        path: `/public/v1/schools/${school}/training-requests`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags TrainingSignupRequests
     * @name TrainingSignupRequestsStoreTrainer
     * @summary Отправить заявку на запись на занятие к тренеру
     * @request POST:/public/v1/trainers/{trainer}/training-requests
     */
    trainingSignupRequestsStoreTrainer: (
      trainer: string,
      data: StoreTrainingSignupRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        TrainingSignupRequestCreated,
        | {
            /** Application error message. */
            message: string;
            /** Application error code. */
            code: number;
            /** Application exception class basename. */
            exception: string;
          }
        | {
            /** Errors overview. */
            message: string;
            /** A detailed description of each field that failed validation. */
            errors: Record<string, string[]>;
          }
      >({
        path: `/public/v1/trainers/${trainer}/training-requests`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
}
